import styled from "styled-components";

export const StyledSelectSpecialtyContainer = styled.div`
  
  margin-top: 32px;
  
  .first-step-icon{
    padding: 10px;
    background-color: #DDF9E4;
    border-radius: 3px;
  }
  
  .main-container{
    border: 1px solid rgba(81, 37, 143, 0.5);
    border-radius: 8px;
    
    p{
      background: rgba(81, 37, 143, 0.2);
      border-radius-top-left: 8px;
      border-radius-top-right: 8px;
      padding: 4px 0 4px 16px;
    }
    
    .ant-form-item{
      justify-content: center;
    }
  }
  
  .admission{
     &__error{
       margin-bottom: 24px;
       padding: 0;
       border-radius: 4px;
       
       
       .ant-alert-message{
         padding: 4px 24px;
       }
       
       .ant-alert-icon{
        padding: 14px;
        background: #DC3545;
       }
     }
  }
  
  .ant{
    &-table{
      
      &-container{
        border-bottom-left-radius: 8px;
      }
    
      &-thead{
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        
        th{
          padding: 2px 2px 2px 6px !important;
        }
      }
    
      &-tbody{
        td{
          padding: 2px 2px 2px 6px !important;
        }
        
        tr:last-child{
          border-bottom-left-radius: 8px;

          td:first-child{
            border-bottom-left-radius: 8px;
          }

          td:last-child{
            border-bottom-right-radius: 8px;
          }
        }
        
        .ant-btn{
          top: 0;
          
          border: none;
          box-shadow: none;
        }
      }
    }
    
    &-btn{
      svg{
        position: relative;
        bottom: 2px;
      }
    }
  }
  `